import React from 'react';
import _ from 'lodash';

import Form from '../../../../gd-form/form/form-modal/form-modal.jsx';
import FormError from '../../../../gd-form/common/form-error/form-error.tsx';
import FormManager from '../../../../gd-form/common/form-manager';
import ButtonSubmitDeprecated from 'core/gd-form/common/btn-submit/btn-submit';

import SettingsFormProto from '../../settings-form-proto';
import ItemsListEditorFormElement from "core/gd-ui/items-list-editor/items-list-editor-form-element";

class StringSettingsForm extends SettingsFormProto {

    constructor(props) {
        super(props);

        // ad size field
        // listItemsIncSeed - changed to 0 and the first one will always be 1 (before it was 2)
        this.initFormData.listItemsIncSeed = _.get(this.props.field, 'params.listItemsIncSeed', 0);
        this.formStructure.fields.listItemsIncSeed = {
            type: 'input',
            isRequired: false
        };

        this.initFormData.listItems = _.get(this.props.field, 'params.listItems', null);
        this.formStructure.fields.listItems = {
            type: 'select',
            isRequired: true,
            label: 'List Items',
            validator: (val) => {
                let res = true;
                if (!val || val.length < 1) return 'Add at least one item';
                val.map(i => {
                    if (i.value.trim() === '') res = 'Options items should not be empty';
                });
                return res;
            }
        };


        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit(result) {

        result.type = gd.const.customFields.type.STRING;

        const field = this.props.field;
        field.label = result.name.trim();
        field.description = result.description;
        field.isRequired = result.isRequired;
        field.params = {
            listItems: result.listItems,
            listItemsIncSeed: result.listItemsIncSeed,
        };

        this.props.onSubmit(field);
    }

    render() {
        return (
            <div className="form-container">
                {this.renderForm()}
                <div className="modal-submit">
                    <ButtonSubmitDeprecated form={this.form} className="submit" label="Submit" />
                </div>
            </div>
        );
    }

    renderForm() {

        return (
            <Form form={this.form} className="create-new-custom-field-form main" submitButton={false}>

                {this.renderType()}
                {this.renderName()}
                {this.renderDescription()}
                {this.renderIsRequired()}

                <div className="row cf list-block">
                    <div className="label">Select options</div>
                    <div className="element">
                        <ItemsListEditorFormElement form={this.form}
                                                    name="listItems"
                                                    incSeedName="listItemsIncSeed"/>
                    </div>
                    <div className="cf" />
                    <FormError form={this.form} name="listItems" />
                    <div className="cf" />
                </div>


            </Form>
        );
    }
}



export default function renderStringFormFieldFormElement(field, props) {
    return <StringSettingsForm field={field} {...props} />;
}
